import { Member } from '@cpd-app/core-module/models';

export const userFeatureKey = 'user';

export interface UserState {
  loading: boolean;
  users: Member[];
  verifiedEmail: string;
  /**
   * SEC-2. The token from the invite's email-verify link. Setting the
   * password sends it back so the server can tell the invitee from anyone
   * else who knows the address.
   */
  verificationToken: string;
  /**
   * ANALYTICS.22. True when the last load failed, so a screen can say so
   * instead of showing nothing and leaving the reader to guess.
   */
  loadFailed: boolean;
}

export const initialUserState: UserState = {
  loading: false,
  users: [],
  verifiedEmail: null,
  verificationToken: null,
  loadFailed: false
};
